import { createSlice } from '@reduxjs/toolkit'

export const chooseItemSlice = createSlice({
  name: 'chooseItem',
  initialState: {
    value: {}
  },
  reducers: {
    setItems: (state, action) => {
      state.value = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setItems } = chooseItemSlice.actions

export default chooseItemSlice.reducer